module.exports = __webpack_public_path__ + "static/media/facebook.52d26cc0.png";